// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__MHcFS {
  background: var(--bg-base) !important;
  box-shadow: 1px 0 0 var(--border);
  position: relative;
}

.Sidebar_sidebar__MHcFS,
.Sidebar_sidebar__MHcFS.ant-layout-sider {
  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
              min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
              max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu,
.Sidebar_sidebar__MHcFS .ant-menu-dark,
.Sidebar_sidebar__MHcFS .ant-menu-dark .ant-menu-sub {
  background: transparent !important;
}

.Sidebar_logo__8wM8\\+ {
  position: relative;
  height: 56px;
  margin: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-surface);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  cursor: pointer;
  overflow: hidden;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.Sidebar_logo__8wM8\\+:hover {
  background: var(--bg-hover);
  border-color: var(--border-strong);
}

.Sidebar_logo__8wM8\\+:active { transform: scale(0.98); }

.Sidebar_logoBolt__NGI2U {
  position: absolute;
  display: inline-flex;
  width: 24px;
  height: 24px;
  color: var(--accent-hover);
}

.Sidebar_logoBolt__NGI2U svg { width: 100%; height: 100%; }

.Sidebar_logoText__t8zMQ {
  position: absolute;
  display: inline-flex;
  align-items: center;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.02em;
  white-space: nowrap;
  background: var(--accent-grad);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.Sidebar_sidebar__MHcFS .ant-menu {
  padding: 8px 12px;
  border-right: none !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-item,
.Sidebar_sidebar__MHcFS .ant-menu-submenu-title {
  margin: 2px 0 !important;
  border-radius: var(--radius-sm) !important;
  height: 42px !important;
  line-height: 42px !important;
  color: var(--text-secondary) !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: background 0.15s ease, color 0.15s ease !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-item:hover,
.Sidebar_sidebar__MHcFS .ant-menu-submenu-title:hover {
  background: var(--bg-hover) !important;
  color: var(--text-primary) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-item-selected {
  background: var(--accent-glow) !important;
  color: var(--accent-hover) !important;
  position: relative;
}

.Sidebar_sidebar__MHcFS .ant-menu-item-selected::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 22px;
  background: var(--accent-grad);
  border-radius: 0 3px 3px 0;
}

.Sidebar_sidebar__MHcFS .ant-menu-item .anticon,
.Sidebar_sidebar__MHcFS .ant-menu-submenu-title .anticon,
.Sidebar_sidebar__MHcFS .ant-menu-item svg,
.Sidebar_sidebar__MHcFS .ant-menu-submenu-title svg {
  width: 18px;
  height: 18px;
  color: inherit;
  stroke: currentColor;
}

.Sidebar_sidebar__MHcFS .ant-menu-item-selected .menu-icon,
.Sidebar_sidebar__MHcFS .ant-menu-item-selected svg {
  color: var(--accent-hover) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: var(--text-primary) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-sub {
  background: var(--bg-surface) !important;
  border-radius: var(--radius-sm) !important;
  margin: 4px 0 4px 8px !important;
  padding: 4px 0 !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-sub .ant-menu-item {
  height: 38px !important;
  line-height: 38px !important;
  padding-left: 44px !important;
  font-size: 13px !important;
  color: var(--text-muted) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-sub .ant-menu-item:hover {
  color: var(--text-primary) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-sub .ant-menu-item-selected {
  background: var(--bg-hover) !important;
  color: var(--accent-hover) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-sub .ant-menu-item-selected::before {
  display: none;
}

.Sidebar_sidebar__MHcFS .ant-menu-submenu-arrow {
  color: var(--text-muted) !important;
}

.Sidebar_sidebar__MHcFS .ant-menu-submenu:hover .ant-menu-submenu-arrow {
  color: var(--text-secondary) !important;
}

.Sidebar_sidebar__MHcFS.ant-layout-sider-collapsed .Sidebar_logo__8wM8\\+ {
  margin: 16px 12px;
}

.Sidebar_sidebar__MHcFS.ant-layout-sider-collapsed .ant-menu-item-selected::before {
  display: none;
}

.Sidebar_sidebar__MHcFS .ant-menu-title-content {
  color: inherit !important;
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.Sidebar_sidebar__MHcFS.ant-layout-sider-collapsed .ant-menu-title-content,
.Sidebar_sidebar__MHcFS .ant-menu-inline-collapsed .ant-menu-title-content {
  opacity: 0;
}

.Sidebar_sidebar__MHcFS .ant-layout-sider-children {
  overflow-y: auto;
  overflow-x: hidden;
}

.Sidebar_sidebar__MHcFS .ant-layout-sider-children::-webkit-scrollbar { width: 4px; }
.Sidebar_sidebar__MHcFS .ant-layout-sider-children::-webkit-scrollbar-track { background: transparent; }
.Sidebar_sidebar__MHcFS .ant-layout-sider-children::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: 2px;
}
.Sidebar_sidebar__MHcFS .ant-layout-sider-children::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}

.Sidebar_sidebar__MHcFS .ant-menu-item:focus-visible,
.Sidebar_sidebar__MHcFS .ant-menu-submenu-title:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
}

@media (max-width: 768px) {
  .Sidebar_sidebar__MHcFS {
    position: fixed;
    left: 0; top: 0; bottom: 0;
    z-index: 1000;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.5);
  }
  .Sidebar_sidebar__MHcFS.ant-layout-sider-collapsed {
    left: -80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Layout/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;EAEE;;qEAEmE;AACrE;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,+BAAe,sBAAsB,EAAE;;AAEvC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,+BAAgB,WAAW,EAAE,YAAY,EAAE;;AAE3C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,0CAA0C;EAC1C,uBAAuB;EACvB,4BAA4B;EAC5B,uCAAuC;EACvC,2BAA2B;EAC3B,0BAA0B;EAC1B,8DAA8D;AAChE;;AAEA;;EAEE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iEAAiE;AACnE;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wEAAkE,UAAU,EAAE;AAC9E,8EAAwE,uBAAuB,EAAE;AACjG;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;IACf,OAAO,EAAE,MAAM,EAAE,SAAS;IAC1B,aAAa;IACb,yCAAyC;EAC3C;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".sidebar {\n  background: var(--bg-base) !important;\n  box-shadow: 1px 0 0 var(--border);\n  position: relative;\n}\n\n.sidebar,\n.sidebar:global(.ant-layout-sider) {\n  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n              min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n              max-width 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.sidebar :global(.ant-menu),\n.sidebar :global(.ant-menu-dark),\n.sidebar :global(.ant-menu-dark) :global(.ant-menu-sub) {\n  background: transparent !important;\n}\n\n.logo {\n  position: relative;\n  height: 56px;\n  margin: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-surface);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  cursor: pointer;\n  overflow: hidden;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.logo:hover {\n  background: var(--bg-hover);\n  border-color: var(--border-strong);\n}\n\n.logo:active { transform: scale(0.98); }\n\n.logoBolt {\n  position: absolute;\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  color: var(--accent-hover);\n}\n\n.logoBolt svg { width: 100%; height: 100%; }\n\n.logoText {\n  position: absolute;\n  display: inline-flex;\n  align-items: center;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  white-space: nowrap;\n  background: var(--accent-grad);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.sidebar :global(.ant-menu) {\n  padding: 8px 12px;\n  border-right: none !important;\n}\n\n.sidebar :global(.ant-menu-item),\n.sidebar :global(.ant-menu-submenu-title) {\n  margin: 2px 0 !important;\n  border-radius: var(--radius-sm) !important;\n  height: 42px !important;\n  line-height: 42px !important;\n  color: var(--text-secondary) !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  transition: background 0.15s ease, color 0.15s ease !important;\n}\n\n.sidebar :global(.ant-menu-item):hover,\n.sidebar :global(.ant-menu-submenu-title):hover {\n  background: var(--bg-hover) !important;\n  color: var(--text-primary) !important;\n}\n\n.sidebar :global(.ant-menu-item-selected) {\n  background: var(--accent-glow) !important;\n  color: var(--accent-hover) !important;\n  position: relative;\n}\n\n.sidebar :global(.ant-menu-item-selected)::before {\n  content: '';\n  position: absolute;\n  left: -12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 22px;\n  background: var(--accent-grad);\n  border-radius: 0 3px 3px 0;\n}\n\n.sidebar :global(.ant-menu-item) :global(.anticon),\n.sidebar :global(.ant-menu-submenu-title) :global(.anticon),\n.sidebar :global(.ant-menu-item) svg,\n.sidebar :global(.ant-menu-submenu-title) svg {\n  width: 18px;\n  height: 18px;\n  color: inherit;\n  stroke: currentColor;\n}\n\n.sidebar :global(.ant-menu-item-selected) :global(.menu-icon),\n.sidebar :global(.ant-menu-item-selected) svg {\n  color: var(--accent-hover) !important;\n}\n\n.sidebar :global(.ant-menu-submenu-selected) > :global(.ant-menu-submenu-title) {\n  color: var(--text-primary) !important;\n}\n\n.sidebar :global(.ant-menu-sub) {\n  background: var(--bg-surface) !important;\n  border-radius: var(--radius-sm) !important;\n  margin: 4px 0 4px 8px !important;\n  padding: 4px 0 !important;\n}\n\n.sidebar :global(.ant-menu-sub) :global(.ant-menu-item) {\n  height: 38px !important;\n  line-height: 38px !important;\n  padding-left: 44px !important;\n  font-size: 13px !important;\n  color: var(--text-muted) !important;\n}\n\n.sidebar :global(.ant-menu-sub) :global(.ant-menu-item):hover {\n  color: var(--text-primary) !important;\n}\n\n.sidebar :global(.ant-menu-sub) :global(.ant-menu-item-selected) {\n  background: var(--bg-hover) !important;\n  color: var(--accent-hover) !important;\n}\n\n.sidebar :global(.ant-menu-sub) :global(.ant-menu-item-selected)::before {\n  display: none;\n}\n\n.sidebar :global(.ant-menu-submenu-arrow) {\n  color: var(--text-muted) !important;\n}\n\n.sidebar :global(.ant-menu-submenu):hover :global(.ant-menu-submenu-arrow) {\n  color: var(--text-secondary) !important;\n}\n\n.sidebar:global(.ant-layout-sider-collapsed) .logo {\n  margin: 16px 12px;\n}\n\n.sidebar:global(.ant-layout-sider-collapsed) :global(.ant-menu-item-selected)::before {\n  display: none;\n}\n\n.sidebar :global(.ant-menu-title-content) {\n  color: inherit !important;\n  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.sidebar:global(.ant-layout-sider-collapsed) :global(.ant-menu-title-content),\n.sidebar :global(.ant-menu-inline-collapsed) :global(.ant-menu-title-content) {\n  opacity: 0;\n}\n\n.sidebar :global(.ant-layout-sider-children) {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.sidebar :global(.ant-layout-sider-children)::-webkit-scrollbar { width: 4px; }\n.sidebar :global(.ant-layout-sider-children)::-webkit-scrollbar-track { background: transparent; }\n.sidebar :global(.ant-layout-sider-children)::-webkit-scrollbar-thumb {\n  background: var(--border-strong);\n  border-radius: 2px;\n}\n.sidebar :global(.ant-layout-sider-children)::-webkit-scrollbar-thumb:hover {\n  background: var(--text-muted);\n}\n\n.sidebar :global(.ant-menu-item):focus-visible,\n.sidebar :global(.ant-menu-submenu-title):focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: -2px;\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: 0; top: 0; bottom: 0;\n    z-index: 1000;\n    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.5);\n  }\n  .sidebar:global(.ant-layout-sider-collapsed) {\n    left: -80px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__MHcFS`,
	"logo": `Sidebar_logo__8wM8+`,
	"logoBolt": `Sidebar_logoBolt__NGI2U`,
	"logoText": `Sidebar_logoText__t8zMQ`
};
export default ___CSS_LOADER_EXPORT___;
